import styled, { css } from 'styled-components';
import { media } from 'src/components/base';

type ProductMediaProps = {
  $isFallbackImage: boolean;
  $more: boolean;
};

export const StyledProductMedia = styled.button<ProductMediaProps>`
  width: 200px;
  height: 210px;
  position: relative;

  ${props =>
    props.$isFallbackImage &&
    css`
      opacity: 0.2;
      max-height: 100%;
      max-width: 100%;
    `}

  ${props =>
    props.$more &&
    css`
      cursor: pointer;
    `}

  ${media.smallOnly`
    width: 100px;
    height: 100px;
  `}
`;

export const StyledFirstImage = styled.div`
  max-width: 200px;
  max-height: 200px;
`;

export const StyledCounters = styled.div`
  padding: 5px 5px;
  position: absolute;
  bottom: 0;
  left: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  transform: translate(-50%, 0);
  color: ${p => p.theme.colors.base500};
  white-space: nowrap; /* Prevent wrapping in mobile mode (kludge) */
`;
